import { gql } from "@apollo/client";

import { identifierFragment } from "./IdentifierFragment";

export const blacklistedIdentifierFragment = gql`
  fragment BlacklistedIdentifierFragment on BlacklistedCaseIdentifier {
    element {
      name
      typeCode
    }
    identifier {
      ...IdentifierFragment
    }
    blacklistElement {
      blacklist {
        name
        code
      }
    }
  }

  ${identifierFragment}
`;
